function moduleResponsiveImage() {
	/**
	 * Responsive-image module zoomable feature
	 */
	document.querySelectorAll('.module.responsive-image .image-container.zoomable .desktop-image').forEach((containerElement) => {
		const dialog = containerElement.querySelector('dialog');
		const removePopupContainer = () => {
			dialog.close();
		};
		dialog.addEventListener('click', removePopupContainer);

		const mediaQuery = window.matchMedia('(min-width: 768px)');
		mediaQuery.addEventListener('change', () => {
			if (!mediaQuery.matches) {
				removePopupContainer();
			}
		});
		containerElement.querySelectorAll('img').forEach((img) => img.addEventListener('click', () => {
			if (mediaQuery.matches) {
				dialog.showModal();
			}
		}));
	});
}
